const tmsRouteMap = {
  welcome: "/welcome",
  home: "/home",
  login: "/login",
  devotees: "/devotees",
  temple_management: "/temple-management",
  temple_settings: "/temple-settings",
  update_page: "/update",
  pos: "/pos",
  pos_sevas: "/pos/sevas",
  // pos_parokshaseva: "/pos/paroksha-seva",
  // pos_pratyakshaseva: "/pos/pratyaksha-seva",
  pos_donation: "/pos/donation",
  pos_petty_donation: "/pos/petty-donation",

  pos_darshanam: "/pos/darshanam",
  pos_kalayanakatta: "/pos/kalyanakatta",
  pos_tollgate: "/pos/toll-gate",
  pos_thulabharam: "/pos/thulabharam",
  pos_products: "/pos/products",
  pos_prasadam: "/pos/prasadam",
  pos_accommodation: "/pos/accommodation",
  pos_accommodation_dashboard: "/pos/accommodation-dashboard",

  pos_accommodation_rooms: "/pos/accommodation/rooms",
  pos_prasadm_scanner: "/pos/prasadam-scanner",
  pos_performance_sccanner: "/pos/performance-scanner",
  pos_ticket_details: "/pos/ticket-details",
  pos_check_in_scan: "/pos/check-in-scan",
  pos_pre_assigned_check_in_scan: "/pos/pre-assigned-check-in-scan",

  pos_acc_scan: "/pos/accommodation-scan",

  serviceManagement: "/service-management",
  serviceManagement_manual_entry: "/service-management/manual-entry",
  serviceManagement_manual_entry_category:
    "/service-management/manual-entry/Category",
  pos_manual_entry: "/pos/manual-entry",
  report_manual_entry: "/reports/manual-report",

  serviceManagement_counter_management:
    "/service-management/counter-management",
  serviceManagement_counter_management_manage_shifts:
    "/service-management/counter-management/manage-shift",

  serviceManagement_shift_management: "/service-management/shift-management",
  serviceManagement_coupon_management: "/service-management/coupon-management",
  serviceManagement_parokshaseva: "/service-management/paroksha-seva",
  serviceManagement_sevas: "/service-management/sevas",
  sms_add_new_seva: "/service-management/sevas/add-new-seva",
  sms_seva_disable_dates: "/service-management/sevas/disable-dates",
  sms_seva_booking_details: "/service-management/sevas/booking-details",
  sms_sevas_manage_slots: "/service-management/sevas/manage-slots",
  sms_sevas_manage_counters:
    "/service-management/sevas/manage-slots/manage-counters",
  sms_sevas_manage_quota: "/service-management/sevas/slots/manage-online-quota",

  serviceManagement_donation: "/service-management/donation",
  sms_add_new_donation: "/service-management/donation/add-new-donation",
  sms_donation_donor_registartion:
    "/service-management/donation/donor-registartion",
  sms_donation_manage_counters: "/service-management/donation/manage-counters",

  serviceManagement_darshanam: "/service-management/darshanam",
  //-----------------------Kalayanakatta ---------------------------------//
  serviceManagement_kalayanakatta: "/service-management/kalyanakatta",
  sm_kalyanakatta_add_new_kalyanakatta:
    "/service-management/kalyanakatta/add-new-kalyanakatta",
  sm_kalyanakatta_manage_tonsure:
    "/service-management/kalyanakatta/manage-tonsure",
  sm_kalyanakatta_manage_performer:
    "/service-management/kalyanakatta/manage-performer",
  //-----------------------Kalayanakatta ---------------------------------//

  serviceManagement_tollgate: "/service-management/toll-gate",

  serviceManagement_thulabharam: "/service-management/thulabharam",
  serviceManagement_publications: "/service-management/publications",
  serviceManagement_prasadam: "/service-management/prasadam",

  serviceManagement_footfall: "/service-management/footfall",
  //----------------------------accommodation----------------------------------//
  serviceManagement_accommodation: "/service-management/accommodation",
  sm_accommodation_and: "/service-management/accommodation/add-new",
  sm_accommodation_disable: "/service-management/accommodation/disable",
  sm_acc_manage_pos: "/service-management/accommodation/Manage-pos",

  sm_acc_manage_room_categories:
    "/service-management/accommodation/manage-room-categories",

  sm_acc_mrc_manage_room:
    "/service-management/accommodation/manage-room-categories/manage-room",
  sm_acc_mrc_manage_quota:
    "/service-management/accommodation/manage-room-categories/manage-quota",
  //----------------------------accommodation----------------------------------//
  serviceManagement_products: "/service-management/products",
  sm_products_and: "/service-management/products/add-new",
  sm_products_manage_pos: "/service-management/products/Manage-pos",

  sm_products_manage_files: "/service-management/products/file-management",
  sm_products_manage_files_add:
    "/service-management/products/file-management/add-new",

  //----------------------------products---------------------------------------//

  smd_darshanam_add_new_darshanam:
    "/service-management/darshanam/add-new-darshanam",
  smd_darshanam_booking_details:
    "/service-management/darshanam/booking-details",
  smd_darshanam_manage_slots: "/service-management/darshanam/manage-slots",
  smd_darshanam_manage_counters:
    "/service-management/darshanam/manage-slots/manage-counters",
  smd_darshanam_manage_quota:
    "/service-management/darshanam/slots/manage-online-quota",
  smd_darshanam_disable_dates: "/service-management/darshanam/disable-dates",

  smd_prasadam_add_new_prasadam:
    "/service-management/prasadam/add-new-prasadam",
  smd_prasadam_booking_details: "/service-management/prasadam/booking-details",
  smd_prasadam_manage_counter:
    "/service-management/prasadam/manage-slots/manage-counters",

  sm_prasadam_inventory: "/service-management/prasadam-inventory",
  sm_prasadam_inventory_add_new:
    "/service-management/prasadam-inventory/add-new",
  sm_prasadam_inventory_stock: "/service-management/prasadam-inventory/stock",

  sm_thulabharam_add_new_thulabharam:
    "/service-management/thulabharam/add-new-thulabharam",
  sm_thulabharam_booking_details:
    "/service-management/thulabharam/booking-details",
  sm_thulabharam_manage_counter:
    "/service-management/thulabharam/manage-slots/manage-counters",

  sm_tollgate_add_new_tollgate:
    "/service-management/toll-gate/add-new-toll-gate",
  sm_tollgate_booking_details: "/service-management/toll-gate/booking-details",
  sm_tollgate_manage_counter: "/service-management/toll-gate/manage-counters",

  orders: "/orders",
  reports: "/reports",
  reports_shift_report: "/reports/shift-report",
  reports_scan_logs: "/reports/scan-logs",
  reports_consolidated_reports: "/reports/consolidated-report",

  reports_darshanam: "/reports/darshanam",
  reports_darshanam_summary_report: "/reports/darshanam/summary-report",

  reports_prasadam: "/reports/prasadam-counter",
  reports_prasadam_summary_report: "/reports/prasadam/summary-report",

  reports_thulabharam: "/reports/thulabharam-counter",
  reports_thulabharam_summary_report: "/reports/thulabharam/summary-report",

  reports_seva: "/reports/seva",
  reports_seva_summary_report: "/reports/seva/summary-report",

  reports_donation: "/reports/donation",
  reports_donation_summary_report: "/reports/donation/summary-report",

  reports_tollgate: "/reports/tollgate",
  reports_tollgate_summary_report: "/reports/tollgate/summary-report",

  reports_accommodation: "/reports/accommodation",
  reports_accommodation_summary_report: "/reports/accommodation/summary-report",

  reports_kalyanakatta: "/reports/kalyanakatta",
  reports_kalyanakatta_summary_report: "/reports/kalyanakatta/summary-report",
  reports_kalyanakatta_performer_report:
    "/reports/kalyanakatta/performer-report",

  reports_view_shift_transactions: "/reports/shift-report/shift-management",
  reports_view_shift_scan_logs: "/reports/shift-report/scan-logs",

  userManagement: "/user-management/",
  userManagement_manage_users: "/user-management/manage-users",
  userManagement_user_details: "/user-management/user-details",
  support: "/support",
  calender: "/calender",
};
export default tmsRouteMap;
